var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-list"},[_c('div',{staticClass:"page-title"},[_vm._v("Message List")]),_c('div',{staticClass:"container"},[_c('common-msg-list',{attrs:{"store":_vm.store}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }